export const colonyInvoiceType = (invoice) => invoice.invoice_type === "payroll" ? "payroll" : "regular";

export const isOutstandingColonyInvoice = (invoice) => {
  if (invoice.is_deleted || ["void", "voided", "cancelled", "canceled"].includes(invoice.status)) return false;
  // Match the statement's sent-invoice billing basis. Payment alone does not
  // establish that a draft was sent, even when its status says partial/paid.
  const sent = Boolean(invoice.sent_at) || invoice.status === "sent";
  const balance = Number(invoice.balance_due ?? (Number(invoice.total || 0) - Number(invoice.amount_paid || 0)));
  return sent && Number.isFinite(balance) && balance > 0.005;
};

export const filterColonyStatementInvoices = (invoices, status = "outstanding", type = "all") => (
  (invoices || []).filter(invoice =>
    (type === "all" || colonyInvoiceType(invoice) === type) &&
    (status === "all" || isOutstandingColonyInvoice(invoice))
  )
);